import { Edit, useForm } from "@refinedev/antd";
import { Form, Input, Tag, Space } from "antd";
import { IResourceComponentsProps } from "@refinedev/core";
import { DollarOutlined } from "@ant-design/icons";

import { ICurrency } from "interfaces";
import { FormSection, FormFieldGrid } from "components/form";

export const CurrencyEdit: React.FC<IResourceComponentsProps> = () => {
  const {
    formProps,
    saveButtonProps,
    formLoading: isLoading,
  } = useForm<ICurrency>();

  return (
    <Edit
      breadcrumb={false}
      saveButtonProps={saveButtonProps}
      headerProps={{
        onBack: () => window.history.back(),
        subTitle: "edit currency",
        tags: isLoading ? (
          <Tag color="orange">loading</Tag>
        ) : (
          <Tag color="green">live</Tag>
        ),
      }}
    >
      <Form {...formProps} layout="vertical">
        <Space direction="vertical" size={24} style={{ width: "100%" }}>
          <FormSection
            title="Currency Information"
            subtitle="Currency details and symbols"
            icon={<DollarOutlined />}
            variant="elevated"
          >
            <FormFieldGrid columns={3}>
              <Form.Item
                label="Currency Name"
                name="name"
                rules={[{ required: true }]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                label="Currency Code"
                name="code"
                rules={[{ required: true }]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                label="Currency Symbol"
                name="symbol"
                rules={[{ required: true }]}
              >
                <Input />
              </Form.Item>
            </FormFieldGrid>
          </FormSection>
        </Space>
      </Form>
    </Edit>
  );
};
